import { scrollToSection } from "../constants/site";

export const Logo = ({ light = false }) => (
    <a
        href="#inicio"
        data-testid="logo-home-link"
        onClick={(e) => {
            e.preventDefault();
            if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
            else window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="flex items-center gap-2.5"
        aria-label="Drax Filmes - início"
    >
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#E50914] shadow-lg shadow-[#E50914]/30 transition-transform duration-300 hover:scale-105">
            <svg viewBox="0 0 24 24" className="h-4 w-4 text-white" fill="currentColor">
                <path d="M8 5.5v13a1 1 0 0 0 1.54.84l10-6.5a1 1 0 0 0 0-1.68l-10-6.5A1 1 0 0 0 8 5.5Z" />
            </svg>
        </span>
        <span
            className={`font-display text-xl font-extrabold leading-none tracking-tight ${
                light ? "text-white" : "text-[#0F172A]"
            }`}
        >
            DRAX<span className="text-[#E50914]">.</span>
            <span
                className={`mt-1 block text-[9px] font-bold uppercase tracking-[0.4em] ${
                    light ? "text-white/50" : "text-[#64748B]"
                }`}
            >
                Filmes
            </span>
        </span>
    </a>
);
